<div class="sidenav text-center">
  <div class="login-main-text">
    <h2>
      <img src="/assets/images/logo-dark.png" alt="ICX"> <br>
      LICX</h2>
    <h3></h3>
    <p>Oh no, hai dimenticato la password? <br>
      Niente paura, ci pensiamo noi!</p>
  </div>
</div>
<div class="main">
  <div class="col-md-12 col-sm-12 col-lg-8">
    <div class="login-form">
      <h2 class="ml-2 mt-2">Recupera password</h2>
      <form *ngIf="form" [formGroup]="emailData" (ngSubmit)="onSubmit()" #f="ngForm">
        <div class="form-group">
          <div class="col-md-12">
            <label for="inputEmail">Inserisci l'email con cui ti sei registrato</label>
            <input formControlName="email" type="email" class="form-control rounded-pill mt-3"
                   name="inputEmail" id="inputEmail" placeholder="Email" required
                   email>
          </div>
        </div>
        <div class="form-group">
          <div class=" col-md-12">
            <p *ngIf="message" class="text-danger">{{message}}</p>
            <button type="submit"
                    class="btn btn-success rounded-pill"
                    [disabled]="!emailData.valid">INVIA
            </button>

          </div>
        </div>
      </form>
      <form *ngIf="!form" [formGroup]="setNewPassword" (ngSubmit)="onSubmitPsw()">
        <div class="form-group">

          <label class="col-sm-12 pl-0" for="newPassword">
            Nuova password
            <input id="newPassword"
                   type="text"
                   class="form-control"
                   formControlName="newPassword"
                   required>
          </label>
          <label class="col-sm-12 pl-0" for="newPasswordCheck">
            Conferma nuova password
            <input id="newPasswordCheck"
                   type="text"
                   class="form-control"
                   formControlName="newPasswordCheck"
                   required>
          </label>
          <input type="hidden" formControlName="token">
        </div>

        <button class="btn btn-info btn-round" type="submit" [disabled]="!setNewPassword.valid">
          <span class="text-white">Cambia password</span>
        </button>

      </form>
    </div>
  </div>
</div>
